import { render, staticRenderFns } from "./LookupDetailInput.vue?vue&type=template&id=bdb27498&scoped=true&"
import script from "./LookupDetailInput.vue?vue&type=script&lang=js&"
export * from "./LookupDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./LookupDetailInput.vue?vue&type=style&index=0&id=bdb27498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb27498",
  null
  
)

export default component.exports